import Modal from 'react-modal';
import './AcceptPersonalData.css';
import React, {useEffect, useState} from "react";
import axios from "axios";

const AcceptPersonalData = ({isOpen, onRequestClose}) => {

    const closeAccept = () => {
        onRequestClose(false);
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeAccept}
            contentLabel="Соглашение"
            className="register-accept-modal"
            overlayClassName="modal-overlay"
            appElement={document.getElementById('root')}
        >
            <div className="register-accept">
                <button className={'close-accept-modal'} onClick={closeAccept}>X</button>
                <div className={'register-accept-text'} style={{whiteSpace: "pre-line"}}>

                    <br/><br/>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ<br/><br/>

                    Настоящим согласием и в соответствии с п. 4 ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О
                    персональных данных» выражаю свое согласие и разрешаю ООО «Пандора Телеком»,
                    ИНН: 4028071930, КПП: 402801001, ОГРН: 1214000006736,
                    находящемуся по адресу: 248010, Калужская обл, г Калуга, ул Комсомольская роща, зд. 39, стр. 40,
                    помещ. 307 обрабатывать мои персональные данные:
                    Моими персональными данными являются следующие сведения, относящиеся ко мне как к физическому лицу
                    (субъекту персональных данных),
                    указанные в процессе регистрации в веб-приложении по адресу https://kort40.online.:<br/><br/>

                    • Адрес электронной почты<br/>
                    • Номер мобильного телефона<br/>
                    • Фамилия, Имя, Отчество<br/>
                    • Никнейм или подобные данные<br/><br/>

                    Своей волей и в своих интересах выражаю согласие на осуществление ООО «Пандора Телеком», любых
                    действий в отношении моих персональных данных,
                    которые необходимы или желаемы для достижения целей договора на оказание услуг по доступу на корт, в
                    том числе выражаю согласие на обработку без ограничения моих
                    персональных данных, включая сбор, систематизацию, накопление, хранение, уточнение (обновление,
                    изменение), использование, распространение (в т. ч. передачу),
                    обезличивание, блокирование, уничтожение персональных данных при автоматизированной и без
                    использования средств автоматизации обработке;<br/>
                    запись на электронные носители и их хранение;<br/>
                    передачу ООО «Пандора Телеком», по своему усмотрению данных и соответствующих документов, содержащих
                    персональные данные,
                    третьим лицам, включая банки, государственные органы исполнительной или судебной власти,
                    уполномоченным агентам и организациям;<br/>
                    хранение моих персональных данных в течение срока, содержащихся в документах, образующихся в
                    деятельности ООО «Пандора Телеком», согласно Федерального
                    закона от 22 октября 2004 № 125-ФЗ «Об архивном деле в Российской Федерации», а также при
                    осуществлении любых иных действий с моими персональными данными,
                    указанными в договоре на оказание услуг по доступу на корт и/или полученными в течение срока
                    действия данного договора, в соответствии с требованиями действующего
                    законодательства РФ и Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».<br/><br/>

                    Настоящее согласие на обработку персональных данных действует с момента представления бессрочно и
                    может быть отозвано мной при представлении ООО «Пандора Телеком»,
                    заявления в простой письменной форме в соответствии с требованиями законодательства Российской
                    Федерации.<br/><br/><br/>


                </div>

                <div className={'register-close-bottom-button-container'}>
                    <button className={'close-accept-modal-bottom'} onClick={closeAccept}>Закрыть</button>
                </div>

            </div>
        </Modal>
    );
}

export default AcceptPersonalData;